import { ReactNode } from "react";

export function LogoWithBadge({
  logoUrl,
  logo,
  badgeUrl,
  size,
}: {
  logoUrl?: string;
  logo?: ReactNode;
  badgeUrl?: string;
  size?: "sm" | "md" | "lg";
}) {
  const sizeClasses = {
    sm: { main: "h-6 w-6", badge: "h-3 w-3 -bottom-1" },
    md: { main: "h-8 w-8", badge: "h-3.5 w-3.5 -bottom-0.5" },
    lg: { main: "h-10 w-10", badge: "h-5 w-5 -bottom-2" },
  };

  const currentSize = sizeClasses[size || "sm"];

  return (
    <div className="relative">
      {logo ? (
        <div className={`${currentSize.main} overflow-hidden rounded-md`}>
          {logo}
        </div>
      ) : logoUrl ? (
        <img
          alt={`Logo`}
          src={logoUrl}
          className={`${currentSize.main} rounded-md`}
        />
      ) : null}
      {badgeUrl ? (
        <img
          alt={`Badge`}
          src={badgeUrl}
          className={`${currentSize.badge} bg-white rounded-full absolute -right-0.5`}
        />
      ) : null}
    </div>
  );
}
